<template>
  <el-dialog title="设置备注和标签" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="备注" prop="value">
        <el-input placeholder="添加备注名" v-model="form.value" maxlength="20" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceContactsApi from '@/api/customer/custServiceContacts'
function initFormBean() {
  const formBean = {
    value: null,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        value: [{ required: true, message: '请添加备注名', trigger: 'blur' }],
      },
      currentUser: null,
    }
  },
  created() {

  },
  methods: {
    handleShow(currentUser) {
      this.form = initFormBean()
      this.form.value = currentUser.contactsRemark
      this.formVisible = true
      this.currentUser = currentUser
    },
    async doCreate() {
      this.$refs["dataForm"].validate(async (valid) => {  // 这里的回调函数也要加 async
        if (valid) {
          try {
            let { contactsRemark, toUserId, toUserInfoId, toUserType, fromUserId } = this.currentUser
            if (contactsRemark) {
              let { data } = await custServiceContactsApi.updateRemark({
                userId: toUserId,
                userInfoId: toUserInfoId,
                remark: this.form.value,
                userType: toUserType,

              })
              this.$EventBus.$emit('handleRemarkSuccess', data)
            } else {
              let { data } = await custServiceContactsApi.creatRemark({
                userId: toUserId,
                userInfoId: toUserInfoId,
                remark: this.form.value,
                userType: toUserType,
              })
              this.$EventBus.$emit('handleRemarkSuccess', data)
            }
            this.$message.success('设置成功')
            this.formVisible = false
          } catch (error) {
          }
        }
      });
    },

  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  i {
    cursor: pointer;
  }
}

.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
